import * as React from 'react';
import * as styles from './PeopleFinderPanel.css';
import { IAPersonaImage } from '../../personaImage/PersonaImage';
import { IAIcon } from '../../icon/Icon';
import { IAPanel } from '../../panels';
import { IPeopleFinderPerson } from '../../../interfaces/IPeopleFinderPerson';
import { IPeopleFinderDesign } from '../../../interfaces/IPeopleFinderDesign';
import { inject, observer } from 'mobx-react';
import { PeopleFinderStore } from '../stores/PeopleFinderStore';
import { Environment } from '../../../services/Environment';
import { Helper } from '../../../Helper';

export interface IPeopleFinderPanelProps {
  peopleFinderStore?: PeopleFinderStore;
  isPanelOpen: boolean;
  person: IPeopleFinderPerson;
  design: IPeopleFinderDesign;
  coverImage: string;
}

@inject('peopleFinderStore')
@observer
export class PeopleFinderPanel extends React.Component<IPeopleFinderPanelProps> {
  public constructor(props: IPeopleFinderPanelProps) {
    super(props);
  }

  public skillsAndAboutme = () => {
    return (
      <React.Fragment>
        {this.props.person.skills?.length > 0 && (
          <div className={styles.IA_peopleFinder_panel_profileSkillsWrapper} style={{ marginTop: this.props.person.skills.length > 0 ? 10 : undefined }}>
            {this.props.person.skills?.map((skill, index) => (
              <div key={index} className={styles.IA_peopleFinder_panel_profileSkillsButton}>
                {skill}
              </div>
            ))}
          </div>
        )}
        <div className={styles.IA_peopleFinder_panel_profileAboutMeWrapper}>{this.props.person.aboutMe && this.props.person.aboutMe}</div>
      </React.Fragment>
    );
  };

  private loading = () => (
    <div className={styles.IA_peopleFinder_searchInputListShowMoreAndSpinnerWrapper}>
      <div className={styles.IA_peopleFinder_searchInputListCardSpinner}>
        <IAIcon title="Spinner" size={20} color={this.props.peopleFinderStore.design.colors.iconColor} />
      </div>
    </div>
  );

  public render() {
    console.log(this.props.peopleFinderStore.selectedPerson);
    return (
      <IAPanel
        open={this.props.isPanelOpen}
        close={() => this.props.peopleFinderStore.closePanel()}
        showNavigationBar={false}
        width={400}
        isMobile={false}
        transition={'slide'}
      >
        {this.props.person && (
          <React.Fragment>
            <div className={styles.IA_peopleFinder_panel_closeButtonWrapper}>
              <div
                onClick={() => this.props.peopleFinderStore.closePanel()}
                className={styles.IA_peopleFinder_panel_closeButton}
                style={
                  {
                    // backgroundColor: this.props.backgroundColor != undefined ? Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.backgroundColor, '#ffffff', '#333333') : '#ffffff',
                  }
                }
              >
                <IAIcon color={this.props.design.colors.iconColor} title={'Close'} size={25} />
              </div>
            </div>
            <div className={styles.IA_peopleFinder_panel_coverImage} style={{ backgroundImage: `url(${this.props.coverImage})` }} />
            <div className={styles.IA_peopleFinder_panel_profilePhotoWrapper}>
              <div className={styles.IA_peopleFinder_panel_profilePhotoBackground}>
                <div className={styles.IA_peopleFinder_panel_profilePhoto}>
                  <IAPersonaImage
                    profileImage={Helper.getProfileImageUrlFromImageAPI(
                      Environment.getEnvironmentForImageAPI(this.props.peopleFinderStore.environment),
                      this.props.peopleFinderStore.tenantName,
                      this.props.peopleFinderStore.token,
                      this.props.person.email
                    )}
                    name={this.props.person.displayName}
                    size={115}
                    fontSize={58}
                  />
                </div>
              </div>
            </div>
            <div className={styles.IA_peopleFinder_panel_profileDetailWrapper}>
              <div className={styles.IA_peopleFinder_panel_profileDetailName}>{this.props.person.displayName}</div>
              <div className={styles.IA_peopleFinder_panel_profileDetailProperty}>
                {this.props.person.jobTitle && (
                  <React.Fragment>
                    <div className={styles.IA_peopleFinder_panel_profileDetailIcon} />
                    <div className={styles.IA_peopleFinder_panel_profileDetailValue}>{this.props.person.jobTitle}</div>
                  </React.Fragment>
                )}
              </div>
              {this.props.person.department && (
                <div className={styles.IA_peopleFinder_panel_profileDetailProperty}>
                  <React.Fragment>
                    <div className={styles.IA_peopleFinder_panel_profileDetailIcon}>
                      <IAIcon size={23} color={this.props.design.colors.iconColor} title={'Organization'} />
                    </div>
                    <div className={styles.IA_peopleFinder_panel_profileDetailValue}>{this.props.person.department}</div>
                  </React.Fragment>
                </div>
              )}
              {this.props.person.officeLocation && (
                <div className={styles.IA_peopleFinder_panel_profileDetailProperty}>
                  <React.Fragment>
                    <div className={styles.IA_peopleFinder_panel_profileDetailIcon}>
                      <IAIcon size={23} color={this.props.design.colors.iconColor} title={'Location'} />
                    </div>
                    <div className={styles.IA_peopleFinder_panel_profileDetailValue}>{this.props.person.officeLocation}</div>
                  </React.Fragment>
                </div>
              )}
              {this.props.person.email && (
                <div className={styles.IA_peopleFinder_panel_profileDetailProperty}>
                  <React.Fragment>
                    <div className={styles.IA_peopleFinder_panel_profileDetailIcon}>
                      <IAIcon size={23} color={this.props.design.colors.iconColor} title={'Email'} />
                    </div>
                    <div className={styles.IA_peopleFinder_panel_profileDetailValue} style={{ color: this.props.peopleFinderStore.design.colors.highlightColor }}>
                      <a href={`tel:${this.props.person.email}`}>{this.props.person.email}</a>
                    </div>
                  </React.Fragment>
                </div>
              )}
              {this.props.person?.mobilePhone && (
                <div className={styles.IA_peopleFinder_panel_profileDetailProperty}>
                  <React.Fragment>
                    <div className={styles.IA_peopleFinder_panel_profileDetailIcon}>
                      <IAIcon size={23} color={this.props.design.colors.iconColor} title={'Phone'} />
                    </div>
                    <div className={styles.IA_peopleFinder_panel_profileDetailValue} style={{ color: this.props.peopleFinderStore.design.colors.highlightColor }}>
                      <a href={`tel:${this.props.person?.mobilePhone}`}>{this.props.person?.mobilePhone}</a>
                    </div>
                  </React.Fragment>
                </div>
              )}
              {this.props.person?.businessPhone && (
                <div className={styles.IA_peopleFinder_panel_profileDetailProperty}>
                  <React.Fragment>
                    <div className={styles.IA_peopleFinder_panel_profileDetailIcon}>
                      <IAIcon size={23} color={this.props.design.colors.iconColor} title={'Phone'} />
                    </div>
                    <div className={styles.IA_peopleFinder_panel_profileDetailValue} style={{ color: this.props.peopleFinderStore.design.colors.highlightColor }}>
                      <a href={`tel:${this.props.person?.businessPhone}`}>{this.props.person?.businessPhone}</a>
                    </div>
                  </React.Fragment>
                </div>
              )}
              <div className={styles.IA_peopleFinder_panel_profileSkillsAboutmeWrapper}>{this.props.peopleFinderStore.isFecthingSkillsAndDescription ? this.loading() : this.skillsAndAboutme()}</div>
            </div>
          </React.Fragment>
        )}
      </IAPanel>
    );
  }
}
